import React from 'react';

function PlateformePage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Plateforme</h1>
      <p>Page `fhc-plateforme.html` convertie en composant React.</p>
    </div>
  );
}

export default PlateformePage;
